import styled, { keyframes } from "styled-components";

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

const PRIMARY = "#01AB7D";
const BORDER = "#E7E8EC";
const TEXT_DARK = "#131313";
const TEXT_MUTED = "#5E5E60";
const SURFACE = "#FFFFFF";
const SURFACE_ALT = "#F4F5F9";

export const Wrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 61px);
  padding: 40px 24px;

  @media (max-width: 575px) {
    min-height: calc(100vh - 49px);
    align-items: flex-start;
    padding: 28px 16px 48px;
  }
`;

export const Card = styled.div`
  width: 100%;
  max-width: 560px;
  background: ${SURFACE};
  border: 1px solid ${BORDER};
  border-radius: 10px;
  padding: 36px 32px;
  box-shadow: 0 12px 32px rgba(19, 19, 19, 0.06);
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (max-width: 575px) {
    padding: 24px 18px;
    box-shadow: none;
  }
`;

export const Kicker = styled.p`
  font-size: 13px;
  font-weight: 600;
  color: ${PRIMARY};
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin: 0;
`;

export const Title = styled.h1`
  font-size: 22px;
  font-weight: 700;
  color: ${TEXT_DARK};
  margin: 0;
  line-height: 1.3;

  @media (max-width: 575px) {
    font-size: 19px;
  }
`;

export const Subtitle = styled.p`
  font-size: 14px;
  color: ${TEXT_MUTED};
  margin: 0;
  line-height: 1.55;

  strong { color: ${TEXT_DARK}; }
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 8px;
`;

export const OptionButton = styled.button`
  width: 100%;
  min-height: 52px;
  padding: 14px 16px;
  border-radius: 7px;
  border: 1.5px solid ${BORDER};
  background: ${SURFACE};
  color: ${TEXT_DARK};
  font-size: 14px;
  font-weight: 600;
  text-align: left;
  cursor: pointer;
  transition: border-color 160ms ease, background 160ms ease;

  &:hover { border-color: ${PRIMARY}; background: #F4FBF9; }
`;

export const PrimaryButton = styled.button`
  width: 100%;
  height: 48px;
  border: 0;
  border-radius: 5px;
  background: ${PRIMARY};
  color: #fff;
  font-weight: 600;
  font-size: 15px;
  cursor: pointer;

  &:disabled { opacity: 0.6; cursor: not-allowed; }
`;

export const SecondaryButton = styled.button`
  width: 100%;
  height: 48px;
  border: 1px solid ${BORDER};
  border-radius: 5px;
  background: ${SURFACE};
  color: ${TEXT_DARK};
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;

  &:hover { background: ${SURFACE_ALT}; }
  &:disabled { opacity: 0.6; cursor: not-allowed; }
`;

export const LinkButton = styled.button`
  background: transparent;
  border: 0;
  padding: 4px 0;
  align-self: center;
  color: ${TEXT_MUTED};
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  text-decoration: underline;

  &:hover { color: ${TEXT_DARK}; }
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  label {
    font-size: 12px;
    color: ${TEXT_DARK};
    font-weight: 500;
    margin: 0;
  }
  input {
    height: 44px;
    border-radius: 5px;
    border: 1px solid ${BORDER};
    padding: 0 12px;
    font-size: 14px;
    color: ${TEXT_DARK};
    background: ${SURFACE};

    &:focus {
      outline: none;
      border-color: ${PRIMARY};
      box-shadow: 0 0 0 3px #B3E6D8;
    }
  }
  .err {
    color: #F64E60;
    font-size: 12px;
    margin: 0;
  }
`;


export const Loading = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  padding: 24px 0;

  p {
    font-size: 14px;
    color: ${TEXT_MUTED};
    margin: 0;
  }
`;

export const Spinner = styled.span`
  width: 34px;
  height: 34px;
  border: 3px solid #D1D5DB;
  border-top-color: ${PRIMARY};
  border-radius: 50%;
  animation: ${spin} 0.7s linear infinite;
`;

export const PeriodTabs = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
`;

export const PeriodTab = styled.button`
  height: 40px;
  border-radius: 7px;
  border: 1.5px solid ${({ active }) => (active ? PRIMARY : BORDER)};
  background: ${({ active }) => (active ? "#F4FBF9" : SURFACE)};
  color: ${({ active }) => (active ? PRIMARY : TEXT_MUTED)};
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: border-color 160ms ease, background 160ms ease;
`;

export const PlanOption = styled.button`
  position: relative;
  width: 100%;
  text-align: left;
  padding: 14px 44px 14px 16px;
  border-radius: 8px;
  border: 1.5px solid ${({ active }) => (active ? PRIMARY : BORDER)};
  background: ${SURFACE};
  cursor: pointer;
  transition: border-color 160ms ease;

  &:hover { border-color: ${({ active }) => (active ? PRIMARY : "#9FBEB4")}; }

  .badge {
    display: inline-block;
    background: #B3E6D8;
    color: #017858;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    border-radius: 4px;
    padding: 2px 8px;
    margin-bottom: 6px;
  }
  .name {
    display: block;
    font-size: 14px;
    font-weight: 700;
    color: ${TEXT_DARK};
  }
  .price {
    display: block;
    margin-top: 4px;
    font-size: 13px;
    color: ${TEXT_MUTED};

    strong { color: ${TEXT_DARK}; }
  }
  .radio {
    position: absolute;
    right: 14px;
    top: 50%;
    transform: translateY(-50%);
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: 2px solid ${({ active }) => (active ? PRIMARY : "#C4C7D1")};
    background: ${({ active }) =>
      active
        ? `radial-gradient(circle, ${PRIMARY} 45%, #fff 50%)`
        : "#fff"};
    transition: border-color 160ms ease, background 160ms ease;
  }
`;
